import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Heart } from "lucide-react";

// Phone-only persistent Donate button (hidden on the Donate page itself). Appears once the visitor scrolls past the hero.
export const MobileDonateBar = () => {
    const { pathname } = useLocation();
    const [shown, setShown] = useState(false);

    useEffect(() => {
        const onScroll = () => setShown(window.scrollY > 420);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (pathname === "/donate") return null;

    return (
        <div
            data-testid="mobile-donate-bar"
            aria-hidden={!shown}
            className={`md:hidden fixed inset-x-0 bottom-0 z-40 px-4 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] bg-[#3D2008]/95 backdrop-blur border-t-2 border-[#C9A84C] transition-transform duration-300 ${shown ? "translate-y-0" : "translate-y-full pointer-events-none"}`}>
            <Link to="/donate" data-testid="mobile-donate-bar-btn"
                className="flex items-center justify-center gap-2 w-full h-12 bg-[#C4522A] text-white font-anton uppercase tracking-wider border-2 border-[#C9A84C] active:translate-y-[2px] transition-transform">
                <Heart size={16} fill="currentColor" /> Donate Now
            </Link>
        </div>
    );
};
